import React from 'react';

export default function RecapCard({ data, onConfirm, onCancel }) {
  return (
    <div className="bg-white border-2 border-ia rounded-lg p-6 my-4 ml-8">
      <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
        📋 Récapitulatif
      </h3>

      <div className="space-y-2 text-sm">
        {data.legumeName && (
          <div className="flex justify-between">
            <span className="text-gray-600">Légume :</span>
            <span className="font-medium">{data.legumeName}</span>
          </div>
        )}
        {data.quantite && (
          <div className="flex justify-between">
            <span className="text-gray-600">Quantité :</span>
            <span className="font-medium">{data.quantite} {data.unite}</span>
          </div>
        )}
        {data.commentaire && (
          <div className="flex justify-between">
            <span className="text-gray-600">Commentaire :</span>
            <span className="font-medium">{data.commentaire}</span>
          </div>
        )}
      </div>

      <div className="flex gap-4 mt-6">
        <button
          onClick={onConfirm}
          className="flex-1 px-4 py-3 min-h-[48px] bg-ia text-white rounded-full hover:bg-ia-dark"
        >
          ✅ Confirmer
        </button>
        <button
          onClick={onCancel}
          className="flex-1 px-4 py-3 min-h-[48px] border border-gray-300 rounded-full hover:bg-gray-50"
        >
          ✏️ Modifier
        </button>
      </div>
    </div>
  );
}
